import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {ColumnConstraint} from 'notebook/tables/constants/TableColumnConstants';

export default function toStructuredTableColumn(
  columnConstraint: ColumnConstraint | null
): StructuredTableColumn | null {
  return columnConstraint != null && columnConstraint.structuredTableColumn != null
    ? columnConstraint.structuredTableColumn
    : null;
}
